var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { appear: "", name: "transition-scale-fade" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowing,
              expression: "isShowing",
            },
          ],
          ref: "modal",
          staticClass: "modal",
          style: _vm.componentStyle,
        },
        [
          _c(
            "article",
            {
              class: `${_vm.modalClass} card roomy with-close modal-content transition-scale-fade-content`,
            },
            [
              _vm._t("title", function () {
                return [
                  _vm.title
                    ? _c(
                        "div",
                        {
                          class: [
                            "text-left",
                            _vm.hasSections
                              ? "section padding-bottom-lg"
                              : "padding-bottom-2xl",
                          ],
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "display-flex flex-items-center",
                              staticStyle: { gap: "var(--spacing-md)" },
                            },
                            [
                              _c("h2", { class: _vm.titleClass }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.title) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._t("title-tag"),
                            ],
                            2
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              }),
              _vm._v(" "),
              _vm._t("content", function () {
                return [
                  _c(
                    "div",
                    { class: ["text-left", { section: _vm.hasSections }] },
                    [_vm._t("default")],
                    2
                  ),
                ]
              }),
              _vm._v(" "),
              _vm._t("footer", function () {
                return [
                  _vm.hasActions
                    ? _c(
                        "div",
                        {
                          class: [
                            "text-left",
                            _vm.hasSections ? "section" : "padding-top-2xl",
                          ],
                        },
                        [_vm._t("actions")],
                        2
                      )
                    : _vm._e(),
                ]
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close margin-top-0",
                  attrs: {
                    type: "button",
                    "aria-label": _vm.closeLabel,
                    "data-balloon-pos": "left",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$emit("close-modal")
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.duotone.faCircleXmark, size: "lg" },
                  }),
                ],
                1
              ),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }